import { UserGroupGrant } from '@eagle/core-data-types';
import { useTheme } from '@mui/material';
import { SxProps } from '@mui/system';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { T_MANY } from '../../constants';
import { CacheDataTypes } from '../../types';
import { GroupChipElement } from '../group-chip-element';
import { ListPaperColumn } from '../list-item';

interface Props {
  'data-testid'?: string;
  groups: UserGroupGrant[];
  sx?: SxProps;
}

export const UserGroupColumn: FC<Props> = ({ groups, sx, ...props }) => {
  const { t } = useTranslation(['common', 'track']);
  const theme = useTheme();

  const groupIds = groups.map((grantGroups) => grantGroups.userGroupId);

  return <ListPaperColumn
    data-testid={props['data-testid']}
    label={t('common:terms.user-group', { count: T_MANY })}
    sx={{ overflow: 'hidden', ...sx }}
    tooltipSlotProps={{
      arrow: {
        sx: {
          color: theme.palette.background.paper,
        },
      },
      tooltip: {
        sx: {
          background: theme.palette.background.paper,
          boxShadow: theme.shadows[6],
          '& .MuiBox-root': {
            background: theme.palette.background.paper,
          },
        },
      },
    }}
  >
    <GroupChipElement type={CacheDataTypes.USER_GROUP} path='user/groups' groupIds={groupIds} />
  </ListPaperColumn>;
};
